import { MOBILE_BOARD, type MobileScoreResponse, type MobileTicketResponse } from '../../shared/protocol.js';

const TIMEOUT_MS = 5_000;

/**
 * The highscore of all phones (on the server). A life gets a ticket when it starts, the result is handed in with it
 * at the end. Without a connection the game goes on as before – then only the personal record counts.
 */
export class GlobalScores {
  private ticket: Promise<string | null> | null = null;

  /** a life starts */
  startRound(): void {
    this.ticket = post<MobileTicketResponse>('/api/mobile/round', {}).then((r) => r?.ticket ?? null);
  }

  /** The life is over: hand in the result → place (0 = not in the top 5) and the top 5, null without a connection. */
  async finish(coins: number, specials: readonly string[]): Promise<MobileScoreResponse | null> {
    const ticket = await (this.ticket ?? Promise.resolve(null));
    this.ticket = null;
    const result = ticket ? await post<MobileScoreResponse>('/api/mobile/score', { ticket, coins, specials }) : null;
    return result ?? (await get<MobileScoreResponse>(`/api/highscore/${MOBILE_BOARD}`));
  }
}

async function post<T>(url: string, body: unknown): Promise<T | null> {
  return request<T>(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
}

async function get<T>(url: string): Promise<T | null> {
  return request<T>(url, {});
}

async function request<T>(url: string, init: RequestInit): Promise<T | null> {
  try {
    const r = await fetch(url, { ...init, cache: 'no-store', signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(TIMEOUT_MS) : undefined });
    return r.ok ? ((await r.json()) as T) : null;
  } catch {
    return null;
  }
}
